import {useEffect} from 'react';
import {t} from 'i18next';
import EmptyState from '../components/page-not-found/EmptyState';
import {useAnalytics} from '../hooks/useAnalytics';
import {GA_ERROR_CODES, GA_ERROR_TYPES} from '../constants/analyticsConstants';

const CatchAllRoute = () => {
  const {trackUserError} = useAnalytics();

  useEffect(() => {
    trackUserError({
      type: GA_ERROR_TYPES.PAGE_NOT_FOUND,
      text: `${t('errors.notFound.title')} ${t('errors.notFound.description')}`,
      code: GA_ERROR_CODES.NOT_FOUND_404,
    });
  }, [trackUserError]);

  return <EmptyState message={t('common.workInProgress')} />;
};

export default CatchAllRoute;
